import { OrderedMap } from "immutable";

export const HEADER_MENU_ITEMS = new OrderedMap({
    actions: {
        icon: "menu",
        key: "actions",
        children: new OrderedMap({
            case_create: {
                key: "case_create",
                icon: "plus",
                label: "Case Create",
                permission: "page_case_create"
            },
            upload_ledger: {
                icon: "plus",
                label: "Upload Ledgers",
                permission: "page_company_sync_request",
                key: "upload_ledger"
            },
            underwriting: {
                key: "underwriting",
                icon: "file",
                label: "Underwriting",
                permission: "page_case_underwriting"
            },
            cibil: {
                icon: "file",
                label: "CIBIL Requests",
                key: "cibil",
                permission: "page_cibil_request"
            },
            adhoc: {
                icon: "global",
                label: "Adhoc",
                key: "adhoc",
                permission: "page_adhoc_edit"
            },
            payment_program: {
                icon: "file",
                label: "Payment Program",
                key: "payment_program",
                permission: "page_payment_program"
            },
            db_onboarding : {
                icon: "user-add",
                label: "DB Onboarding",
                key: "db_onboarding",
                permission: "db_onboarding"
            },
            anchor_onboarding : {
                icon: "user-add",
                label: "Anchor Onboarding",
                key: "anchor_onboarding",
                permission: "anchor_onboarding"
            },           
            companies: {
                key: "companies",
                icon: "global",
                label: "Companies",
                permission: "page_companies_listing",
                children: new OrderedMap ({
                    "company-create": {
                        key: "company-create",
                        icon: "plus",
                        label: "Create New Company"
                    },
                    "company-list": {
                        key: "company-list",
                        icon: "database",
                        label: "Listing",
                        permission: "page_companies_listing"
                    },
                    "invoice-for-disbursal": {
                        key: "invoice-for-disbursal",
                        icon: "upload",
                        label: "Submit Invoices for Disbursal",
                        permission: "page_invoice_for_disbursal"
                    },
                    "review-invoices": {
                        key: "review-invoices",
                        icon: "file-done",
                        label: "Review Invoices",
                        permission: "page_review_invoices"
                    }, 
                    "data-sync": {
                        key: "data-sync",
                        icon: "sync",
                        label: "Data Sync Request",
                        permission: "page_data_sync_requests"
                    }
                })
            },
            pskit_courier: {
                key: "pskit_courier",
                icon: "file",
                label: "PSKit Courier Details",
                permission: "page_pskit_courier_details"
            },
            lenders: {
                key: "lenders",
                icon: "bank",
                label: "Lending Partners",
                permission: "page_lenders_management",
            },
            bank_accounts: {
                key: "bank_accounts",
                icon: "bank",
                label: "Bank Accounts",
                permission: "page_bank_account_management",
            },
            reports: {
                icon: "file",
                label: "Reports",
                key: "reports",
                permission: "page_reports"
            },
            mpa_approval: {
                icon: "file",
                label: "MPA Approval",
                key: "mpa_approval",
                permission: "can_mpa_approve"
            },
            reset_password: {
                icon: "user",
                key: "reset_password",
                label: "Reset Password"
            },
            logout: {
                icon: "logout",
                key: "logout",
                label: "Logout"
            }
        })
    }
});

export const NAVIGATION_MENU_ITEMS = new OrderedMap({
    "/app/inbox": {
        label: "Inbox",
        tag: true
    },
    "/app/participated": {
        label: "Participated",
        tag: true
    },
    "/app/inbox/decision-dashboard": {
        label: "Decisioning Dashboard",
        tag: true
    },
    // "/app/anchor-on-boarding": {
    //     label: "Anchor On-Boarding",
    //     // tag: true
    // },
    // "/app/distributor-on-boarding": {
    //     label: "Distributor On-Boarding",
    //     // tag: true
    // },
    "/app/case/new": {
        label: "Case Create",
        permission: "page_case_create"
    },
    "/app/users-and-groups": {
        label: "Users and Groups",
        permission: "page_user_and_groups"
    },
    "/app/underwriting/": {
        label: "Underwriting",
        target: "/app/underwriting/jobs",
        permission: "page_case_underwriting"
    },
    "/app/reports": {
        label: "Reports",
        target: "/app/reports",
        permission: "page_reports"
        // permission: "view_reports"
    },
    "/app/schemes": {
        label: "Business Programs",
        target: "/app/schemes",
        permission: "page_schemes"
    },
    "/app/checklist": {
        label: "Document Checklist",
        target: "/app/checklist",
        permission: "page_checklist"
    }
});

export const CASE_DETAILS_MENU_ITEMS = new OrderedMap({
    details: {
        label: "Details"
    },
    documents: {
        label: "Documents"
    }
});
